/**
 * @class Sex
 */
export class Sex {
    /** @access private @type {Array[Sex]} */
    static _values = new Array()

    static FEMALE = new Sex('F', '女性')
    static MALE = new Sex('M', '男性')
    static NO_ANSWER = new Sex('N', '無回答')

    /**
     * constructor Sex
     * @constructor
     * @param {string} code
     * @param {string} value
     */
    constructor(code, value) {
        this.code = code
        this.value = value
        Sex._values.push(this)
    }

    /**
     * getter values
     * @returns {Sex[]}
     */
    static get values() {
        return Sex._values
    }

    /**
     * find value
     * @param {string} code
     * @returns {Sex|undefined}
     */
    static findValue(code) {
        return Sex._values.find((sex) => sex.code === code)
    }

    /**
     * getSelectList
     * @returns {Object[]}
     * @property {string} Object.label
     * @property {string} Object.val
     */
    static getSelectList() {
        return Sex._values.map((sex) => {
            return {
                label: sex.value,
                val: sex.code
            }
        })
    }
}

/**
 * @class HttpStatus
 */
export class HttpStatus {
    /** @access private @type {Array[HttpStatus]} */
    static _values = new Array()

    static OK = new HttpStatus(200)
    static FOUND = new HttpStatus(302)
    static BAD_REQUEST = new HttpStatus(400)
    static UNAUTHORIZED = new HttpStatus(401)
    static FORBIDDEN = new HttpStatus(403)
    static NOT_FOUND = new HttpStatus(404)
    static CONFLICT = new HttpStatus(409)
    static GONE = new HttpStatus(410)
    static INTERNAL_SERVER_ERROR = new HttpStatus(500)
    static LOCKED = new HttpStatus(423)

    /**
     * constructor HttpStatus
     * @constructor
     * @param {number} code
     */
    constructor(code) {
        this.code = code
        HttpStatus._values.push(this)
    }
}

/**
 * @class Prefectures
 */
export class Prefectures {
    /** @access @type {Array[string]} */
    static major_prefectures = [
        '東京都',
        '北海道',
        '大阪府',
        '神奈川県',
        '福岡県'
    ]

    /** @access @type {Array[string]} */
    static prefectures = [
        '北海道',
        '青森県',
        '岩手県',
        '宮城県',
        '秋田県',
        '山形県',
        '福島県',
        '茨城県',
        '栃木県',
        '群馬県',
        '埼玉県',
        '千葉県',
        '東京都',
        '神奈川県',
        '新潟県',
        '富山県',
        '石川県',
        '福井県',
        '山梨県',
        '長野県',
        '岐阜県',
        '静岡県',
        '愛知県',
        '三重県',
        '滋賀県',
        '京都府',
        '大阪府',
        '兵庫県',
        '奈良県',
        '和歌山県',
        '鳥取県',
        '島根県',
        '岡山県',
        '広島県',
        '山口県',
        '徳島県',
        '香川県',
        '愛媛県',
        '高知県',
        '福岡県',
        '佐賀県',
        '長崎県',
        '熊本県',
        '大分県',
        '宮崎県',
        '鹿児島県',
        '沖縄県'
    ]

    /**
     * getPrefectures
     * @returns {Object[]}
     * @property {string} Object.label
     * @property {string} Object.val
     */
    static getPrefectures() {
        const ary = []
        ary.push(
            {
                'label': '■主要都市',
                'options': Prefectures.prefectures.filter((prefecture) => {
                        return Prefectures.major_prefectures.includes(prefecture)
                    }).map((prefecture) => {
                    return {
                        label: prefecture,
                        val: prefecture
                    }
                })
            }
        )
        ary.push(
            {
                'label': '■都市一覧',
                'options': Prefectures.prefectures.map((prefecture) => {
                    return {
                        label: prefecture,
                        val: prefecture
                    }
                })
            }
        )
        return ary
    }

    /**
     * getSelectList
     * @returns {Object[]}
     * @property {string} Object.label
     * @property {string} Object.val
     */
    static getSelectList() {
        return [
            {
                label: '',
                val: ''
            }
        ].concat(Prefectures.getPrefectures())
    }
}

/**
 * @class InputEventType
 */
export class InputEventType {
    /** @access private @type {Array[InputEventType]} */
    static _values = new Array()

    static NONE = new InputEventType(0)
    static ZENKAKU = new InputEventType(1)
    static HANKAKU = new InputEventType(2)

    /**
     * constructor InputEventType
     * @constructor
     * @param {number} code
     */
    constructor(code) {
        this.code = code
        InputEventType._values.push(this)
    }
}
